module.exports = __webpack_public_path__ + "static/media/shareworks.283ae2c2.svg";